import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import pako from 'pako';
import { format, isValid, parseISO, fromUnixTime } from "date-fns";

export function decrypt(findresponse, flg){
  
  
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
        iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
}



export function decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
        iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;

}
export function commonData() {
    var common = {};
    var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
    var localdata = has_local_data ? decrypt(localStorage.getItem('encdata'), 0) : '';
    var  apiUrl= decryptconfigdata('apiUrl');
    var studioUrl = decryptconfigdata('studioUrl');
    var userAuthKey = has_local_data ? localdata.user_key : '';
    var userId = has_local_data ? localdata.user_id : '';
    var userEmail = has_local_data ? localdata.user_email : '';
    common['userEmail'] = userEmail,
    common['apiUrl'] = apiUrl,
    common['studioUrl'] = studioUrl,
    common['userAuthKey'] = userAuthKey,
    common['userId'] = userId

    return common;
}

export function rawjsonparse(findresponse, flg) {
        return findresponse;
    }

export function decompressjsondata(bufferData){
    // Decompress the gzip data
    const inflatedData = pako.inflate(new Uint8Array(bufferData), { to: 'string' });
    // Handle the decompressed data
    const findResponse = JSON.parse(inflatedData);
    return findResponse;
}

export const getFormattedDate = (date, formatString = "MMM, dd yyyy") => {
try {
	// Return "NA" if date is null, undefined, empty string, or invalid
	if (!date || date === "" || date === "0" || date === 0) {
	return "NA";
	}

	let dateObj;

	// Handle Unix timestamp (number)
	if (typeof date === "number") {
	dateObj = fromUnixTime(date);
	}
	// Handle string dates
	else if (typeof date === "string") {
	// Check if it's a Unix timestamp string
	const numericValue = parseInt(date, 10);
	if (!isNaN(numericValue) && date === String(numericValue)) {
		dateObj = fromUnixTime(numericValue);
	} else {
		// Try parsing as ISO string or other formats
		dateObj = parseISO(date);

		// If parseISO fails, try new Date()
		if (!isValid(dateObj)) {
		dateObj = new Date(date);
		}
	}
	}
	// Handle Date objects
	else if (date instanceof Date) {
	dateObj = date;
	}
	// Unknown format
	else {
	return "NA";
	}

	// Verify the date is valid
	if (!isValid(dateObj)) {
	return "NA";
	}

	// Format using date-fns
	return format(dateObj, formatString);
} catch (error) {
	console.error("Error formatting date:", error);
	return "NA";
}
};



// WEBPACK FOOTER //
// ./src/actions/common.js